import { makeStyles, visuallyHidden } from "@inductiveautomation/ws-components";
import { CSSObject } from "tss-react";

export const getTrainingStyles = makeStyles()((theme) => ({
  tabBarContainer: {
    background: theme.palette.neutral.white,
  },
  cardIconContainer: {
    maxHeight: "2.5rem",
  },
  alertHref: {
    color: theme.palette.neutral[80],
  },
}));

export const getDrawerStyles = makeStyles()(() => ({
  root: {
    display: "grid",
    placeItems: "center",
    height: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  heading: {
    marginTop: "1.5rem",
    marginBottom: "0.5rem",
    textAlign: "center",
  },
  description: {
    textAlign: "center",
  },
}));

export const getDrawerContentStyles = makeStyles()(() => ({
  alertContainer: {
    padding: "1.5rem 1.5rem 0 1.5rem",
  },
  alertActionIcon: {
    position: "relative",
    left: "0.125rem",
  },
}));

export const getDialogStyles = makeStyles()(() => ({
  imageContainer: {
    display: "flex",
    gap: "2rem",
    paddingBottom: "2rem",
    justifyContent: "center",

    "& img": {
      objectFit: "contain",
    },
  },

  submitTestContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.125rem",
  },

  purchaseTestOverviewContent: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",

    "p:not(last-child)": {
      marginBottom: "1em",
    },
  },

  reviewOrderAlertContainer: {
    marginBottom: "1.5rem",
  },
  reviewOrderFieldsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  reviewOrderTextFieldSplit: {
    maxWidth: "unset",
  },

  visuallyHidden,
}));

export const getStartDialogStyles = makeStyles()((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "center",

    " > svg": {
      width: "10rem",
      height: "10rem",
      color: theme.palette.neutral[50],
    },
  },
  description: {
    textAlign: "center",
  },
  actionsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    justifyContent: "center",
    marginTop: "1rem",
  },
}));

export const getHistoryStyles = makeStyles()({
  root: {
    marginTop: "0.5rem",
  },
  accordionContainer: {
    padding: "0rem 1.5rem 1.5rem 1.5rem",
  },
});

export const getCreditCardStepStyles = makeStyles()((theme) => ({
  h1: {
    ...(theme.typography.h1 as CSSObject),
    color: theme.palette.brand["ia-gray"],
    margin: "0",
  },
  container: {
    display: "flex",
    gap: "2rem",
    flexDirection: "column",
  },
}));

export const getBillingAddressConfirmationDialogStyles = makeStyles()(
  (theme) => ({
    container: {
      display: "flex",
      gap: "1.5rem",
    },
    addressColumnLabel: {
      ...(theme.typography.label as CSSObject),
      marginBottom: "0.75rem",
    },
    addressColumn: {
      flexGrow: 1,
    },
  })
);
